import { BidListItemForSupplierDto, BidViewForSupplierDto, BseBidDeliveredFieldsDto } from "../../autogen/bff-api";

export const isBseBidDraft = (
  bid: BidViewForSupplierDto
): bid is BidViewForSupplierDto & { draftFields: BseBidDeliveredFieldsDto } => {
  return bid.draftFields !== null;
};

export const isDeliveredBseBid = (
  bid: BidViewForSupplierDto
): bid is BidViewForSupplierDto & { deliveredFields: BseBidDeliveredFieldsDto } => {
  return bid.deliveredFields !== null;
};

export const isBseBidDto = (bid: unknown): bid is BidViewForSupplierDto => {
  return (bid as BidViewForSupplierDto).uniqueForBseBidDto === true;
};

export const isBseDto = (bid: unknown): bid is BidListItemForSupplierDto => {
  return (bid as BidListItemForSupplierDto).uniqueForBidDto === true;
};
